export function convertCoordsToShortKeys(location: Partial<Coordinates>) {
  return { lat: location.latitude, lng: location.longitude };
}
